import { type UseQueryResult, useQuery } from 'react-query';
import { type TableParamsType } from '../../types/common';
import {
  ParticipantBrokerAccountUpdatedHistoryService,
  Wealthlane_FinanceIntegrationService_Dtos_ParticipantBrokerAccountDtos_ParticipantBrokerAccountHistoryDto,
} from '../../services/wealthlane-finance-integration-services';

const useGetParticipantBrokerAccountHistory = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  // tableInfo: TableParamsType,
  participantBrokerAccountId: string
): UseQueryResult<
  | Array<Wealthlane_FinanceIntegrationService_Dtos_ParticipantBrokerAccountDtos_ParticipantBrokerAccountHistoryDto>
  | undefined,
  unknown
> => {
  // const { filter, sorting, skipCount, maxResultCount } = tableInfo;

  const switchSandboxList = useQuery(
    ['getParticipantBrokerAccountHistory', participantBrokerAccountId],
    async () => {
      return await handleRequest(
        ParticipantBrokerAccountUpdatedHistoryService.getApiFinanceIntegrationApiAppParticipantBrokerAccountUpdatedHistoryBrokerAccountUpdatedHistoryByParticipantBrokerAccountId(
          participantBrokerAccountId
          // filter
          // sorting,
          // skipCount,
          // maxResultCount
        )
      );
    }
  );

  return switchSandboxList;
};

export default useGetParticipantBrokerAccountHistory;
